import app from '../app.jsx'

function _onSubmitMail (mailObj, callback) {
  const mailData = {
    toEmails: mailObj.toEmails,
    subject: mailObj.subject,
    content: mailObj.content,
    invoiceId: mailObj.id
  }
  const params = { query: { bResend: true } }

  app.service('/api/invoice/mail').timeout = 30000
  app
    .service('/api/invoice/mail')
    .create(mailData, params)
    .then((result) => {
      callback(result)
    })
    .catch((err) => {
      callback(err)
    })
}

function _onDownloadMailInvoice (invoiceId, callback) {
  if (invoiceId) {
    const createObj = {
      invoiceId: invoiceId,
      isActual: false
    }

    app
      .service('/api/invoice/pdf')
      .create(createObj, {})
      .then((pdfRes) => {
        callback(pdfRes)
      })
      .catch((_pdfErr) => {
        callback(null)
      })
  }
}

const InvoiceMailUtil = {}
InvoiceMailUtil.onSubmitMail = _onSubmitMail
InvoiceMailUtil.onDownloadMailInvoice = _onDownloadMailInvoice

export default InvoiceMailUtil
